import React from 'react'

import ProjectLandscapeImage from '../components/project-landscape-image'
import ProjectContainedLandscapeImage from '../components/project-contained-landscape-image'
import ProjectLandscapeGifImage from '../components/project-landscape-gif-image'
import ProjectPortraitImage from '../components/project-portrait-image'
import ProjectContainedPortraitImages from '../components/project-contained-portrait-image'
import VimeoVideo from '../components/video'
import VimeoVideoAutoplay from '../components/vimeo-video-autoplay'

const renderBlock = (param, el, i, postType, func=null) => {
  param = param.replace(postType, '')

  let block = {
    '_Acf_LayoutBlocks_ProjectLandscapeImage' : (el, i) => <ProjectLandscapeImage key={i} {...el} />,
    '_Acf_LayoutBlocks_ProjectContainedLandscapeImage' : (el, i) => <ProjectContainedLandscapeImage key={i} {...el} />,
    '_Acf_LayoutBlocks_ProjectLandscapeGifImage' : (el, i) => <ProjectLandscapeGifImage key={i} {...el} />,
    '_Acf_LayoutBlocks_ProjectPortraitImages' : (el, i) => <ProjectPortraitImage key={i} {...el} />,
    '_Acf_LayoutBlocks_ProjectContainedPortraitImages' : (el, i) => <ProjectContainedPortraitImages key={i} {...el} />,
    '_Acf_LayoutBlocks_VimeoVideo' : (el, i) => <VimeoVideo key={i} {...el} />,
    '_Acf_LayoutBlocks_VimeoVideoAutoplay' : (el, i) => <VimeoVideoAutoplay key={i} {...el} />,
  }[param]

  if (!block) return null

  return block(el, i)
}

export default renderBlock